#import "./TimestampsFull.graphql"
#import "./SearchIndexFull.graphql"
#import "./OrderProductDetailFull.graphql"
#import "./OrderCustomerFull.graphql"
#import "./OrderProductOptionsFull.graphql"
#import "./FakturoidDataFull.graphql"
#import "./GoPayDataFull.graphql"
#import "./OrderVoucherFull.graphql"
#import "./AddressFull.graphql"

fragment OrderFull on Order {
  id
  customer {
    ...OrderCustomerFull
  }
  note
  noteFromProvoz
  orderNumber
  status
  payment {
    status
    type
  }
  deliveryDate
  pickUpBranch
  shippingAddress {
    ...AddressFull
  }
  price {
    deliveryPrice
    totalPrice {
      priceLevel
      withoutTax
      withTax
    }
  }
  products {
    id
    product {
      ...OrderProductDetailFull
    }
    options {
      ...OrderProductOptionsFull
    }
    size
    quantity
    status
    noteFromVyrobna
    noteFromProvoz
  }
  vouchers {
    ...OrderVoucherFull
  }
  proformaUrl
  invoiceUrl
  fakturoidData {
    ...FakturoidDataFull
  }
  goPayData {
    ...GoPayDataFull
  }
  appliedVoucher {
    id
    value {
      type
      absolute
      maxAbsolute
      percentageValue
    }
  }
  compensationVoucher {
    id
    value {
      type
      absolute
      maxAbsolute
      percentageValue
    }
  }
  placesOfProduction
  tenantId
  placedBy
  deliveryTickets {
    number
    branch
  }
  cancelReason
  refundAmount
  refundPercentage
  orderCreatedEmailSent
  cancelEmailSent
  orderReminderSent
  vouchersGenerated
  createdAtPaginationGroup
  deliveryDatePaginationGroup
  ...TimestampsFull
  ...SearchIndexFull
}
